import { render } from "./inventoryList.vue?vue&type=template&id=6f53447d&scoped=true"
import script from "./inventoryList.vue?vue&type=script&lang=js"
export * from "./inventoryList.vue?vue&type=script&lang=js"

import "./inventoryList.vue?vue&type=style&index=0&id=6f53447d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f53447d"]])

export default __exports__